import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import requestTicket from "../api/requestTicket";
import branchListApi from "../api/branchListApi";
import { setInit } from "../../../modules/reducers/arsUrlValidator/checkArsStatus";
import { useDispatch } from "react-redux";
const BRAND = {
  EM: {
    name: "이마트",
    chatBotType: "0315791234",
  },
  TR: {
    name: "트레이더스",
    chatBotType: "0519685600",
  },
  NB: {
    name: "노브랜드",
    chatBotType: "023805111",
  },
  ED: {
    name: "이마트 에브리데이",
    chatBotType: "023805060",
  },
  LD: {
    name: "SSG 랜더스",
    chatBotType: "0211111111",
  },
};

const useInputState = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [brandId, setBrandId] = useState("EM");
  const [storeList, setStoreList] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("01058260934");

  useEffect(() => {
    fetchBranchList();
  }, [brandId])

  useEffect(() => {
  }, [selectedStore])

  const fetchBranchList = async (e) => {
    try {
      const result = await branchListApi(brandId);
      const {data} = result;

      setStoreList(data.storeList);
      setSelectedStore(data.storeList[0].name);
    } catch (e) {
      console.log("E:" + e);
    }
  };

  const handleChange = (data) => {
    setBrandId(data);
  };

  const handlePhoneNumberChange = (data) => {
    setPhoneNumber(data);
  };

  const handleBranchChange = (data) => {
    setSelectedStore(data);
  };

  const fetchUrl = async (e) => {
    e.preventDefault();
    try {
      let store;
      if (brandId === 'LD') {
        store = { tel: BRAND[brandId].chatBotType };
      } else {
        store = storeList.filter(store => store?.name === selectedStore);
        store[0].tel = brandId === 'NB' || brandId === 'ED' ? BRAND[brandId].chatBotType : store[0].tel;
      }
      const result = await requestTicket(store[0]?.tel || BRAND[brandId].chatBotType, phoneNumber);

      if( result.data.startsWith('http') ) {
        var relativeUrl = new URL(result.data);
        var urlParams = new URLSearchParams(relativeUrl.search);

        let params = '';
        for (let [key, value] of urlParams.entries()) {
          params += `${key}=${value}&`;
        }
        params = params.slice(0, -1);

        navigate(`/?${params}`);
      } else {
        navigate(`/?chnlId=${result.data}`);
      }
    } catch (e) {
      console.log("E:" + e);
    }
  };

  useEffect(() => {
    dispatch(setInit());
  }, []);
  return [brandId, phoneNumber, storeList, selectedStore, handlePhoneNumberChange, handleChange, handleBranchChange, fetchUrl];
};

export default useInputState;
